<template>
  <div>
    <a-row>
      <a-col :span="18" :offset="3">
        <!--<a-timeline mode="left">-->
          <!--<a-timeline-item>111</a-timeline-item>-->
          <!--<a-timeline-item>Solve initial network problems 2015-09-01</a-timeline-item>-->
          <!--<a-timeline-item>Technical testing 2015-09-01</a-timeline-item>-->
          <!--<a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>-->
        <!--</a-timeline>-->

        <Card>
          <DescriptionList size="large" title="基本信息" style="margin-bottom: 32px;">
            <Description term="项目标题">{{project_version.name}}</Description>
            <Description term="创建时间">{{project_version.create_time}}</Description>
            <Description term="版本号">{{project_version.version_code_text}}</Description>
          </DescriptionList>
          <DescriptionList size="large" title="项目介绍" style="margin-bottom: 32px;">
            <div>{{project_version.introduce}}</div>
          </DescriptionList>

          <Divider style="margin-bottom: 32px;" />
          <DescriptionList size="large" title="知情同意书" style="margin-bottom: 32px;">
            <Description term="附件">
            <a :href="project_version.informed_consent.url" target="_blank" >{{project_version.informed_consent.name}}</a>
            </Description>
          </DescriptionList>
          <Divider style="margin-bottom: 32px;" />

          <div v-for="annex in annexs" v-bind:key="annex.key">
            <DescriptionList size="large" :title="annex.title" style="margin-bottom: 32px;">
              <div style="margin-left:20px;">{{annex.introduce}}</div>

              <div style="margin-left:20px;">
                <div v-for="u in annex.annexs" v-bind:key="u.key">>
                  <a :href="u.url" target="_blank" >{{u.name}}</a>
                </div>
              </div>
            </DescriptionList>

          </div>

          <!--<DescriptionList size="large" title="知情同意书" style="margin-bottom: 32px;">-->
            <!--<Description term="用户姓名">付小小</Description>-->
            <!--<Description term="联系电话">18100000000</Description>-->
            <!--<Description term="常用快递">菜鸟仓储</Description>-->
            <!--<Description term="取货地址">浙江省杭州市西湖区万塘路18号</Description>-->
            <!--<Description term="备注">无</Description>-->
          <!--</DescriptionList>-->
        </Card>
      </a-col>
    </a-row>
  </div>


</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";
import DescriptionList from "../../components/DescriptionList";
import { Divider, Card } from "ant-design-vue";
const { Description } = DescriptionList;
export default {
  components: {
    DescriptionList,
    Description,
    Divider,
    Card
  },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      old: {},
      project:{},
      project_version:{},
      name: "我是项目名称",
      introduce: "我是项目介绍",
      accept: Global.accept,
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
      //上传请求时是否携带 cookie
      withCredentials: true,
      fileList: [],
      annexs: [],
      closeList: []
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    }
  },
  methods: {
    normFile(e) {
      console.log("Upload event:", e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    getData() {
      request({
        url: "/project/" + this.$route.query.project_id+"/version/"+ this.$route.query.the_id,
        method: "get",
        params: {}
      }).then(response => {
        let data = response.data;
        if (data.success) {
          // this.form.resetFields();
          this.old = data.data;
          this.project=data.data.project;
          this.project_version=data.data.project_version;
          this.annexs=data.data.project_version.items;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleChange(info) {
      // this.fileList = [...info.fileList];
      console.log("info", info);
      if (info.file.status === "removed") {
      }
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        console.log("完成", info.file, info.fileList);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleChange1({ fileList }) {
      console.log('handleChange1',fileList);
      if (fileList && fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }else{
      this.fileList = [];
      }
    },
    // handleChange1(info) {
    //   // this.fileList = [...info.fileList];
    //   console.log("info", info);
    //   if (info.file.status === "removed") {
    //     this.fileList=[];
    //   }
    //   if (info.file.status !== "uploading") {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (info.file.status === "done") {
    //     this.fileList=info.fileList;
    //     this.$message.success(`${info.file.name} file uploaded successfully`);
    //   } else if (info.file.status === "error") {
    //     this.$message.error(`${info.file.name} file upload failed.`);
    //   }
    // },

    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      console.log("打开附件",file)
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
    closeAnnex(i) {
      console.log("关闭嗯", i);
      this.closeList.push(i);
    },
    addAnnex() {
      this.count += 1;
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        console.log("第一步", values);
        if (!err) {
          for (let i = 1; i <= this.count; i++) {
            console.log("看卡" + i, values);
            if (this.closeList.indexOf(i) !== -1) {
              values["title_" + i] = "";
              values["introduce_" + i] = "";
              values["annex_" + i] = "";
            } else {
              let annex = values["annex_" + i];
              if (annex) {
                if (annex.fileList) {
                  annex = annex.fileList;
                }
                values["annex_" + i] = annex.map(x => {
                  console.log("内部x", x, x.response);
                  if (x.response) {
                    return x.response;
                  }
                  return x;
                });
              } else {
                values["annex_" + i] = "";
              }
            }
          }
          if (!this.fileList || this.fileList.length < 1) {
            this.$message.error("请输入知情同意书");
            return;
          }
          values.informed_consent = this.fileList[0];
          console.log(this.form);
          console.log(values);
          values["count"] = this.count;

          request({
            url: "/project/" + this.$route.query.the_id,
            method: "PUT",
            data: values
          }).then(response => {
            let data = response.data;
            if (data.success) {
              this.form.resetFields();
              this.$message.success(data.msg);
              this.$router.push({ path: "/project/all" });
            } else {
              this.$message.error(data.msg);
            }
            console.log(response);
          });
        }
      });
    }
  }
};
</script>
